import {getUpdatedStatistics} from '../api/additionals';
import getProgressFromPast from './getProgressFromPast';

export async function getStatisticsForOffice(officeId) {
	const newTeakTypeObject = {};
	try {
		const updatedStatsData = (await getUpdatedStatistics(officeId)).data;
		const getTotalEntitiesByType = (type) => updatedStatsData.find((teakTypeStats) => teakTypeStats?.teakType === type)?.totalTeakEntities || 0;
		const getTotalBookedEntitiesTodayByType = (type) =>
			updatedStatsData.find((teakTypeStats) => teakTypeStats?.teakType === type)?.teakBookingStats?.teakBookingStatsToday
				.totalBookedTeakEntities || 0;
		const getTotalBookedEntitiesOneWeekAgoByType = (type) =>
			updatedStatsData.find((teakTypeStats) => teakTypeStats?.teakType === type)?.teakBookingStats?.teakBookingStatsOneWeekAgo
				.totalBookedTeakEntities || 0;
		const getActiveEntitiesByType = (type) => updatedStatsData.find((teakTypeStats) => teakTypeStats?.teakType === type)?.activeTeakEntities || 0;


		const createStatsObjectForType = (type) => {
			const totalEntities = getTotalEntitiesByType(type);
			const totalBookedEntitiesToday = getTotalBookedEntitiesTodayByType(type);
			const totalBookedEntitiesOneWeekAgo = getTotalBookedEntitiesOneWeekAgoByType(type);
			const activeEntities = getActiveEntitiesByType(type)
			return {totalEntities, totalBookedEntitiesToday, totalBookedEntitiesOneWeekAgo, activeEntities};
		};

		const workplace = createStatsObjectForType('TeakTypeWorkplace');
		const meetingRoom = createStatsObjectForType('TeakTypeMeetingRoom');
		const parkingSpace = createStatsObjectForType('TeakTypeParkingSpace');
		const totalEntities = workplace.totalEntities + meetingRoom.totalEntities + parkingSpace.totalEntities;
		const totalBookedEntitiesToday =
			workplace.totalBookedEntitiesToday + meetingRoom.totalBookedEntitiesToday + parkingSpace.totalBookedEntitiesToday;
		const totalBookedEntitiesOneWeekAgo =
			workplace.totalBookedEntitiesOneWeekAgo + meetingRoom.totalBookedEntitiesOneWeekAgo + parkingSpace.totalBookedEntitiesOneWeekAgo;
		const totalProgressFromOneWeekAgo = getProgressFromPast(totalBookedEntitiesOneWeekAgo, totalBookedEntitiesToday);
		const totalActiveEntities = workplace.activeEntities + meetingRoom.activeEntities + parkingSpace.activeEntities;
		const total = {totalEntities, totalBookedEntitiesToday, totalBookedEntitiesOneWeekAgo, totalProgressFromOneWeekAgo, totalActiveEntities};

		const stats = {
			workplace,
			meetingRoom,
			parkingSpace,
			total,
		};

		newTeakTypeObject.stats = stats;
	} catch (error) {
		console.log(error);
	}

	return newTeakTypeObject;
}
